"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckControl = exports.getAbstractCheckListProps = exports.getAbstractCheckControlProps = void 0;
const composition_api_1 = require("@vue/composition-api");
const _composables_1 = require("../../_composables");
const InputControl_1 = require("../InputControl");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.getAbstractCheckControlProps = () => ({
    ...InputControl_1.abstractBaseControlProps,
    /**
     * Id of check control.
     */
    id: {
        type: String,
        required: false,
        default: null
    },
    /**
     * Label to display next to control.
     */
    label: {
        type: String,
        required: false,
        default: null
    },
    /**
     * Control's value, synced via `v-model`.
     */
    model: { required: true },
    /**
     * Determines whether the control allows selection of more than one option.
     */
    type: {
        type: String,
        required: false,
        default: 'checkbox'
    },
    /**
     * Array of the options available to select.
     */
    value: {
        required: false,
        default: true
    }
});
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.getAbstractCheckListProps = () => ({
    ...InputControl_1.abstractBaseControlProps,
    /**
     * Control's value, synced via `v-model`.
     */
    model: { required: true },
    /**
     * Determines whether the control allows selection of more than one option.
     */
    multiple: {
        type: Boolean,
        required: false,
        default: false
    },
    /**
     * Array of the options available to select.
     */
    options: {
        type: Array,
        required: true
    }
});
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.useCheckControl = (props, ctx, sizeRegistry, validClassMap = _composables_1.defaultValidationClassMap) => {
    const { errors, valid, model, multiple, size } = composition_api_1.toRefs(props);
    const checked = _composables_1.useSyncModel(model, ctx);
    const checkType = composition_api_1.computed(() => multiple.value ? 'checkbox' : 'radio');
    const hasErrors = _composables_1.useHasErrors(errors);
    const isValid = _composables_1.useIsValid(hasErrors, valid);
    const sizeClass = _composables_1.useSizeClass(size, sizeRegistry);
    const validationClass = _composables_1.useValidMarkerClass(isValid, validClassMap);
    const collapse = {
        list: composition_api_1.ref([]),
        toggleCollapse(key) {
            if (this.list.value.includes(key)) {
                this.list.value = this.list.value.filter((item) => item !== key);
            }
            else {
                this.list.value.push(key);
            }
        },
        isCollapsed(key) {
            return !this.list.value.includes(key);
        },
        clampLines(key) {
            return this.isCollapsed(key) ? 2 : 'auto';
        }
    };
    return { checked, hasErrors, sizeClass, checkType, validationClass, collapse };
};
//# sourceMappingURL=CheckControl.hooks.js.map